export const alphabets = /^[a-zA-Z\s]+$/;
export const alphaNumeric = /^[a-zA-Z0-9\s,-/./(/)]+$/;
export const numbers = /^(\+?\d{1,4})?\d+$/;
export const ifscCode = /^[A-Z]{4}0[A-Z0-9]{6}$/;
export const validateUrl =
    /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;
